import { apiClient } from './api'

export type EvidenceType =
  | 'photo' | 'signature' | 'file' | 'approval' | 'checklist' | 'external_ref'

export interface EvidenceRequirement {
  id: number
  project_id: number
  status_name: string
  evidence_type: EvidenceType
  label: string
  instructions?: string | null
  is_required: boolean
  position: number
}

export interface Evidence {
  id: number
  task_id: number
  requirement_id: number
  attachment_id?: number | null
  payload?: Record<string, unknown> | null
  submitted_by?: number | null
  submitted_at: string
}

export const evidenceService = {
  listRequirements: async (projectId: number, statusName?: string) => {
    const { data } = await apiClient.get<EvidenceRequirement[]>(
      `/api/v1/projects/${projectId}/evidence-requirements`,
      { params: statusName ? { status_name: statusName } : {} },
    )
    return data
  },

  createRequirement: async (projectId: number, body: Omit<EvidenceRequirement, 'id' | 'project_id'>) => {
    const { data } = await apiClient.post<EvidenceRequirement>(
      `/api/v1/projects/${projectId}/evidence-requirements`,
      body,
    )
    return data
  },

  updateRequirement: async (id: number, body: Partial<EvidenceRequirement>) => {
    const { data } = await apiClient.put<EvidenceRequirement>(
      `/api/v1/evidence-requirements/${id}`,
      body,
    )
    return data
  },

  deleteRequirement: async (id: number) => {
    await apiClient.delete(`/api/v1/evidence-requirements/${id}`)
  },

  listForTask: async (taskId: number) => {
    const { data } = await apiClient.get<Evidence[]>(`/api/v1/tasks/${taskId}/evidence`)
    return data
  },

  submit: async (taskId: number, body: { requirement_id: number; attachment_id?: number; payload?: Record<string, unknown> }) => {
    const { data } = await apiClient.post<Evidence>(`/api/v1/tasks/${taskId}/evidence`, body)
    return data
  },

  remove: async (id: number) => {
    await apiClient.delete(`/api/v1/evidence/${id}`)
  },
}
